import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { isIOS } from 'react-device-detect';
import { Col, Grid, Image, Row, Typography } from 'antd';
import Lottie from 'lottie-react';

import CommunityHeader from '../../../public/images/komunitas/CommunityHeader.json';

import classes from './index.module.less';

const KomunitasNewContainer = (props: any) => {
	const { xs } = Grid.useBreakpoint();
	const [checkDevice, setCheckDevice] = useState(String);
	const dataMember = props.waCommunity[0];
	useEffect(() => {
		const handleDeviceDetection = () => {
			if (isIOS) {
				setCheckDevice('ios');
			} else {
				setCheckDevice('no-ios');
			}
		};

		handleDeviceDetection();
	}, []);

	return (
		<div className={classes.pagehero}>
			<div className={classes.headContact}>
				<div className="container">
					<Row>
						<Col md={16} sm={{ span: 16 }} xs={{ span: 24 }} lg={16} xl={16}>
							<Row>
								<Col md={24} sm={24} xs={24} lg={24} xl={24}>
									<div className={classes.left1}>
										<h1 className={classes.title}>
											Tempat Mama <span className={classes.netralcolor}>cerita </span> dan <span className={classes.netralcolor}> tanya</span> <br />
											<span> dengan mama lain 🤗</span>
										</h1>
										{
											!xs && (
												<>
													<Typography className={classes.paragraph}>
														Dari &quot;ini normal gak ya?&quot; sampai &quot;aku ngerasa sendirian&quot; semua boleh disampaikan di sini, Ma. Ada ribuan Mama lain yang siap dengerin dan bagi pengalaman bareng kamu
													</Typography>
													<Row
														style={{ marginTop: '20px', textAlign: xs ? 'center' : 'left' }}
														justify={xs ? 'center' : 'start'}
														align="middle">
														<Col style={{ marginRight: '15px', textAlign: xs ? 'center' : 'left'}}>
															<div className={classes.title2}>
																<CountUp
																	end={!dataMember.total_member_group ? 7400 : dataMember.total_member_group}
																	duration={3}
																/>+
															</div>
															<Typography className={classes.paragraph3}>
																Member Aktif
															</Typography>
														</Col>
														<Col style={{ marginLeft: '15px', textAlign: xs ? 'center' : 'left' }}>
															<div className={classes.title2}>
																<CountUp
																	end={!dataMember.total_wa_group ? 10 : dataMember.total_wa_group}
																	duration={3}
																/>+
															</div>
															<Typography className={classes.paragraph3}>
																Diskusi Perbulan
															</Typography>
														</Col>
													</Row>
												</>
											)
										}
									</div>
								</Col>
							</Row>
						</Col>
						<Col md={8} sm={{ span: 8 }} xs={{ span: 24 }} lg={8} xl={8}>
							<Row>
								<Col md={24} sm={24} xs={24} lg={24} xl={24}>
									<div className={classes.right1}>
										<div className={classes.lottieWrapper}>
											<Lottie animationData={CommunityHeader} loop={true} />
										</div>
										<div className={classes.overlayImage}>
											{!xs && (
												<Image
													src="/images/komunitas/frameBintang.svg"
													alt="image"
													preview={false}
												/>
											)}
										</div>
									</div>
									{
										xs && (
											<>
												<br/>
												<Typography className={classes.paragraph}>
													Dari &quot;ini normal gak ya?&quot; sampai &quot;aku ngerasa sendirian&quot; semua boleh disampaikan di sini, Ma. Ada ribuan Mama lain yang siap dengerin dan bagi pengalaman bareng kamu
												</Typography>
												<Row
													style={{ marginTop: '20px', textAlign: xs ? 'center' : 'left' }}
													justify={xs ? 'center' : 'start'}
													align="middle">
													<Col style={{ marginRight: '15px', textAlign: xs ? 'center' : 'left'}}>
														<div className={classes.title2}>
															<CountUp
																end={!dataMember.total_member_group ? 7400 : dataMember.total_member_group}
																duration={3}
															/>+
														</div>
														<Typography className={classes.paragraph3} style={{marginTop: '5px'}}>
															Member Aktif
														</Typography>
													</Col>
													<Col style={{ marginLeft: '15px', textAlign: xs ? 'center' : 'left' }}>
														<div className={classes.title2}>
															<CountUp
																end={!dataMember.total_wa_group ? 10 : dataMember.total_wa_group}
																duration={3}
															/>+
														</div>
														<Typography className={classes.paragraph3} style={{marginTop: '5px'}}>
															Diskusi Perbulan
														</Typography>
													</Col>
												</Row>
											</>
										)
									}
								</Col>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Col md={15} sm={{ span: 15, order: 2 }} xs={{ span: 24, order: 2 }} lg={15} xl={15}>
							<Row>
								<Col md={24} sm={24} xs={24} lg={24} xl={24}>
									<div className={classes.left2}>
										{
											!xs &&(
												<h2 className={classes.title2}>
													Tentang <span className={classes.netralcolor}>Komunitas</span> Hallobumil{' '}
												</h2>
											)
										}

										<Typography className={classes.paragraph2}>
											Komunitas Hallobumil adalah forum diskusi yang mendukung wanita mulai dari
											program kehamilan, hamil, hingga melahirkan, dengan anggota dari berbagai
											wilayah Indonesia.
										</Typography>
										<p></p>
										<Typography className={classes.paragraph2}>
											Komunitas ini fokus pada 1000 Hari Pertama Kehidupan, menyediakan informasi
											kesehatan, edukasi, dan dukungan bagi member. Selain itu, Hallobumil juga
											membuka peluang kemitraan dengan brand untuk kegiatan positif.
										</Typography>
									</div>
								</Col>
							</Row>
						</Col>
						<Col md={9} sm={{ span: 9, order: 1 }} xs={{ span: 24, order: 1 }} lg={9} xl={9}>
							<Row>
								<Col md={24} sm={24} xs={24} lg={24} xl={24}>
									<div className={classes.right2}>
										{
										xs && (
											<h2 className={classes.title2}>
												Tentang <span className={classes.netralcolor}>Komunitas</span> Hallobumil{' '}
											</h2>
											)
										}
										{xs && checkDevice === 'ios' ? (
											<Image src="/images/komunitas/komunitasHeroSect1.svg" alt="image" preview={false} width={200} height={200} />
										) : xs ? (
											<Image src="/images/komunitas/komunitasHeroSect1.svg" alt="image" preview={false} width={200} height={200} />
										) : (
											<Image src="/images/komunitas/komunitasHeroSect1.svg" alt="image" preview={false} />
										)}
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default KomunitasNewContainer;
